import pulse from "@finn-no/pulse-sdk";
import { merge } from "ts-deepmerge";
import { TrackerData } from "@finn-no/pulse-sdk/dist/types";

/**
 * Deep partial type for recursively making all properties optional
 * Used for merging event data with base tracking information
 */
export type DeepPartial<T> = T extends object
	? {
			[P in keyof T]?: DeepPartial<T[P]>;
		}
	: T;

export const trackClick = (eventData: DeepPartial<TrackerData>) => {
	const baseEvent: DeepPartial<TrackerData> = {
		type: "Click",
		vertical: {
			name: "business_center",
			subVertical: "job",
		},
		object: {
			type: "UIElement",
			elementType: "Button",
			position: "Company Profile",
		},
	};

	return pulse.trackEvent(merge(baseEvent, eventData));
};
